import React from "react";
import Button, {
  buttonSizes,
  buttonThemes
} from "@streeteasy/design-system/deprecated/actions/button";
import { SecondaryLarge } from "@streeteasy/design-system/typography";

import GlobalState from "src/shared/utilities/globalState";

import { ICONS } from "./constants";
import * as S from "./styled";

const SignInRegisterSection = () => {
  const handleSignInRegister = () => {
    window.gon.state.analyticsData = { source: "homepage_module" };
    GlobalState.get("triggerScenario")("EmailCapture");
  };

  return (
    <S.SignInRegisterSection>
      <S.Header>Don&apos;t miss your dream home</S.Header>
      <S.SubHeader>
        Build a profile and let the best listings come to you
      </S.SubHeader>
      <S.Icons>
        {ICONS.map(({ key, src, text }) => (
          <S.Icon key={key}>
            <S.Img src={src} />
            <SecondaryLarge>{text}</SecondaryLarge>
          </S.Icon>
        ))}
      </S.Icons>
      <Button
        onClick={handleSignInRegister}
        size={buttonSizes.LG}
        theme={buttonThemes.PRIMARY}
      >
        Build your profile
      </Button>
    </S.SignInRegisterSection>
  );
};

export default SignInRegisterSection;
